import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import ServiceList from '../components/Services/ServiceList';
import EditService from '../components/Services/EditService';


const Services = () => {
  return (
    <Routes>
      <Route path="/" element={<ServiceList />} />
      <Route path="/edit/:id" element={<EditService />} />
      <Route path="/edit" element={<EditService />} />
    
    </Routes>
  )
}

export default Services;